export enum FieldTypeEnum {
    Integer = 6,
    Float = 7,
    String = 8,
    Boolean = 9
}
